import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import moment from 'moment';
import ChangeReasonDetails from './ChangeReasonDetails';
import { ListGroup, ListGroupItem, Row, Col } from 'react-bootstrap';
import Api from '../../../api/api';

class ChangeReason extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authToken: localStorage.getItem('authToken'),
      httpOther: localStorage.getItem('httpOther'),
      showModal: false,
      showFullLog: false,
      changeReasonSelected: {
        loggedInUser: null,
        recCreateDate: null,
        serviceSiteId: null,
        recCreatedDate: 1557987258000,
        auditDetails: null,
        auditInfoFound: false,
      },
      dealerChanges: [],
    };
  }

  closeModal = () => this.setState({ showModal: false });
  showModal = () => this.setState({ showModal: true });

  handleReasonClick = change => {
    this.setState({ changeReasonSelected: change, showModal: true });
  };

  componentDidMount() {
    const { authToken } = this.state;
    if (authToken == null) {
      this.props.history.push({
        pathname: '/sessionexpired',
        state: {
          error: 'Unauthorised or Session Expired',
          error_description: 'Please try to login again',
        },
      });
    }
    const getAuditDetails = async () => {
      try {
        const params = {
          serviceSiteId: this.props.serviceSiteId,
        };
        const auditDetails = await Api.getAuditDetails(params);
        if (auditDetails.length > 0) {
          this.setState({
            auditInfoFound: true,
            dealerChanges: auditDetails.sort((a, b) =>
              a.recCreatedDate > b.recCreatedDate ? -1 : 1,
            ),
          });
        }
      } catch (error) {
        console.trace('error: ', error);
      }
    };

    getAuditDetails();
  }

  toggleShowFullLog = () => this.setState({ showFullLog: !this.state.showFullLog });

  render() {
    const { dealerChanges, showFullLog, showModal, auditInfoFound } = this.state;
    const alwaysShow = dealerChanges.slice(0, 5);
    const restOfLog = dealerChanges.slice(5);

    const modal = (
      <Modal.Dialog className="dealer-edit-modal" scrollable={true}>
        <Modal.Header closeButton onClick={this.closeModal}>
          <Modal.Title>Audit Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="audit-details">
          <ChangeReasonDetails
            user={this.state.changeReasonSelected.loggedInUser}
            date={this.state.changeReasonSelected.recCreatedDate}
            auditDetails={this.state.changeReasonSelected.auditDetails}
            serviceSiteId={this.state.changeReasonSelected.serviceSiteId}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.closeModal} className="close-btn">
            Close
          </Button>
        </Modal.Footer>
      </Modal.Dialog>
    );

    const auditInformation = (
      <React.Fragment>
        <h5>Newest on top</h5>
        <ListGroup>
          {alwaysShow.map(change => {
            const auditDetails = JSON.parse(change.auditDetails);

            return (
              <div key={change.loggedInUser + change.recCreatedDate}>
                <ListGroupItem className="listGroupItem1">
                  <Row>
                    <Col xs={12} className="listGroupItemCol1">
                      <a onClick={() => this.handleReasonClick(change)}> {change.loggedInUser}</a>{' '}
                      <span className="dealer-edit-reason">
                        {moment(change.recCreatedDate).format('LLL')} {' - '}
                        {auditDetails.reason}
                      </span>
                    </Col>
                  </Row>
                </ListGroupItem>
              </div>
            );
          })}
          {showFullLog &&
            restOfLog.map(change => {
              const auditDetails = JSON.parse(change.auditDetails);

              return (
                <div key={change.loggedInUser + change.recCreatedDate}>
                  <ListGroupItem className="listGroupItem1">
                    <Row>
                      <Col xs={12} className="listGroupItemCol1">
                        <a onClick={() => this.handleReasonClick(change)}> {change.loggedInUser}</a>{' '}
                        <span className="dealer-edit-reason">
                          {moment(change.recCreatedDate).format('LLL')} {' - '}
                          {auditDetails.reason}
                        </span>
                      </Col>
                    </Row>
                  </ListGroupItem>
                </div>
              );
            })}
          {!!restOfLog.length && (
            <button
              onClick={() => this.toggleShowFullLog()}
              className="btn btn-primary dealerButton"
            >
              {showFullLog ? 'Hide' : 'Show'} rest of log ({restOfLog.length})
            </button>
          )}
        </ListGroup>
      </React.Fragment>
    );

    const noAuditInfoFound = <div>No Audit Info Found</div>;

    return (
      <div>
        {showModal && modal}
        {auditInfoFound && auditInformation}
        {!auditInfoFound && noAuditInfoFound}
      </div>
    );
  }
}

export default ChangeReason;



// WEBPACK FOOTER //
// ./src/components/Dealers/ChangeReason/ChangeReason.js